import * as React from "react";
const SvgGrok = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 86,
    height: 98,
    viewBox: "0 0 86 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("path", { d: "M43.2059 97.7143L0.167578 34.9086H19.2928L62.3362 97.7143H43.2059Z", fill: "black" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0.143066 97.7143L19.2785 69.7908L28.8482 83.7554L19.2882 97.7143H0.143066Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M33.6362 48.8377L66.7122 0.571411H85.8573L43.2059 62.8063L33.6362 48.8377Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M70.1768 97.7143V30.4371L85.8573 7.55598V97.7143H70.1768Z", fill: "black" })
);
export default SvgGrok;
